import React, { useCallback, useMemo, useState } from "react";
import { Container, OptionsList, OptionItem } from "./options-check.styled";


export interface Option {
  label: string;
  value: string;
  selected: boolean;
  other?: boolean;
}

interface OptionsRadioProps {
  title?: string;
  options: Option[];
  setOptions: (options: Option[]) => void;
  color: string;
  otherOptionLabel?: string;
}
const OptionsRadio: React.FC<OptionsRadioProps> = ({ title, options, setOptions, color, otherOptionLabel }) => {
  const [otherChecked, setOtherChecked] = useState<boolean>(false);
  
  const otherOption = useMemo(() => (
    options.find(o => o.other) || { label: '', value: '', selected: false }
  ), [options]);

  const handleClick = useCallback((index: number) => {
    const newOptions = options.filter(o => !o.other).map((o, i) => ({
      ...o,
      selected: i === index
    }));
    setOtherChecked(index === -1);
    setOptions(newOptions);
  }, [options, setOptions]);

  const handleInput = useCallback((value: string) => {
    const newOptions = options.filter(o => !o.other);
    if(value.trim() !== '') {
      const newOtherOption: Option = {
        other: true,
        selected: true,
        label: value,
        value: value,
      }
      newOptions.push(newOtherOption);
    }
    setOptions(newOptions);
  }, [options, setOptions]);

  return (
    <Container color={color}>
      {!!title && (
        <p className="title">
          {title}
        </p>
      )}
      <OptionsList>
        {options.filter(o => !o.other).map((option, index) => (
          <OptionItem key={index} color={color}>
            <input
              id={`${index}-${option.value}-option-check`}
              type="radio"
              checked={option.selected}
              onChange={() => handleClick(index)}
              />
            <label htmlFor={`${index}-${option.value}-option-check`}>
              {option.label}
            </label>
          </OptionItem>
        ))}
        <OptionItem color={color}>
          <input
            id={`other-option-check`}
            type="radio"
            checked={otherChecked}
            onChange={() => handleClick(-1)}
            />
          <label htmlFor={`other-option-check`}>
            {otherOptionLabel}
          </label>
          {otherChecked && (
            <input
              type="text"
              placeholder={otherOptionLabel?.toLowerCase()}
              value={otherOption.label}
              onChange={(e) => handleInput(e.target.value)}
            />
          )}
        </OptionItem>
      </OptionsList>
    </Container>
  )
};

export default OptionsRadio;
